// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qZV6","col":"styles_col__2vhnR"};